import { ListItemIcon } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { USER_GROUPS, checkRequiredPermissions } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";

export default function Demos() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return checkRequiredPermissions([
    USER_GROUPS.ADMIN,
    USER_GROUPS.SALES,
    USER_GROUPS.SUPER_USER,
  ]) ? (
    <ListItem
      button
      onClick={() => {
        history.push("/demos");
        dispatch(showSidebar(false));
      }}
    >
      <ListItemIcon>
        <EmojiTransportationIcon />
      </ListItemIcon>
      <ListItemText primary={t("mainSideBar.demos")} />
    </ListItem>
  ) : null;
}
